import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BaseComponentService } from '../../services/base-component.service';
import { BancoArrecadador } from '../../models/pagamento/banco-arrecadador';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'gpa-detalhe-carga-dados',
  templateUrl: './detalhe-carga-dados.component.html'
})
export class DetalheCargaComponent extends BaseComponentService implements OnInit {

  @Input() liquidacao: any; 

  formDetalhe: FormGroup;

  consignatarias: any[];

  async ngOnInit() {

    this.criarFormulario();
    
    this.getBanco(this.liquidacao.codigoBancoCredor).subscribe(bancoArrecadador => {
      const nomeBanco =  bancoArrecadador != null 
        ?  ("000" + bancoArrecadador.id).slice(-3) +" - "+ bancoArrecadador.nome
        : '-';
      this.atualizarControle('codBancoCredor', nomeBanco);
    });  
    
    this.getNomeFormaRecebimento(this.liquidacao.codigoFormaRecebimentoCredor).subscribe(nome => {
      this.atualizarControle('formaRecebimentoCredor', nome != null ? nome : '-');
    });  

    this.atualizarFormulario();

  }

  criarFormulario() {
    this.formDetalhe = this.fb.group({
      formaRecebimentoCredor: this.fb.control({value: '', disabled: true}),
      codBancoCredor: this.fb.control({value: '', disabled: true}),
      codAgenciaCredor: this.fb.control({value: '', disabled: true}),
      contaCredor: this.fb.control({value: '', disabled: true}),
      tipoContaCredor: this.fb.control({value: '', disabled: true})
    });
  }

  atualizarFormulario() { 
    this.atualizarControle('codBancoCredor', 
      this.liquidacao.codBancoCredor!=null?this.liquidacao.codBancoCredor:'-');
    this.atualizarControle('codAgenciaCredor',  
      this.liquidacao.codigoAgenciaCredor!=null?this.liquidacao.codigoAgenciaCredor:"-");
    this.atualizarControle('contaCredor', 
      this.liquidacao.numeroContaBancariaCredor!=null?this.liquidacao.numeroContaBancariaCredor +'/'+ this.liquidacao.digitoContaBancariaCredor:"-");
    this.atualizarControle('tipoContaCredor', 
      this.liquidacao.tipoConta!=null?(this.liquidacao.tipoConta==1?"Conta Corrente":"Poupança"):"-");
 
    this.preencheListaConsignatarias();
  }

 /*
  * Atualiza o conteúdo do controle verificando a nulidade do futuro conteúdo.
  */
  atualizarControle(controle: string, value: any) {
    this.formDetalhe.get(controle).setValue(value === null || value === undefined ? '-' : value.toString());
  }
 
  preencheListaConsignatarias() {
    this.consignatarias = [];

    for (const item of this.liquidacao.consignatarias) {
      this.consignatarias.push({
        codigoCredor: item.codigoCredor,
        nomeTipo: item.nomeTipo,
        nomeFormaRecebimento: item.nomeFormaRecebimento,
        valor: item.valor
      });
    }
  }


  /*
   * Carregar informacao de Banco da API.
   */

  getBanco(idBanco: number): Observable<BancoArrecadador | null>{
    if (idBanco == null) return of(null);
    
    this._service.routePrefix = `/api/BancoArrecadador/${idBanco}`;
 
    return this._service.getById(null, 'gpa').pipe(
      map((bancoArrecadador: BancoArrecadador) => bancoArrecadador)
    );    
  }

  getNomeFormaRecebimento(codForma: number): Observable<string> {
    this._service.routePrefix = `/api/FormaRecebimento/Obter/${codForma}`;
  
    return this._service.getById(null, 'gpa').pipe(
      map((formaRecebimento: any) => formaRecebimento.nome)
    );
  }
  
}



// WEBPACK FOOTER //
// ./src/app/pagamento/carga-dados/detalhe-carga-dados.component.ts